import React from 'react';
import { FormLabel, Select } from '@chakra-ui/react';
import { FormData } from './SdgQuiz';
import { useResponsive } from '#core/SdgQuiz/utils';

enum Answer {
  YES = 'Yes',
  NO = 'No / don’t know',
  MAYBE = 'Maybe / partly',
}

type QuestionFormItemSelectProps = {
  fieldName: string;
  title: string;
  value: string;

  updateFields: (fields: Partial<FormData>) => void;
};

export const QuestionFormItemSelect = ({
  fieldName,
  title,
  value,
  updateFields,
}: QuestionFormItemSelectProps) => {
  const isMobileScreen = useResponsive();

  return (
    <>
      <FormLabel fontSize={isMobileScreen ? 'sm' : 'md'}>{title}</FormLabel>

      <Select
        placeholder="Select one"
        value={value}
        my={5}
        id={fieldName}
        fontSize={isMobileScreen ? 'sm' : 'md'}
        onChange={(e) => updateFields({ [fieldName]: e.target.value })}
      >
        <option value={Answer.YES}>{Answer.YES}</option>
        <option value={Answer.NO}>{Answer.NO}</option>
        <option value={Answer.MAYBE}>{Answer.MAYBE}</option>
      </Select>
    </>
  );
};
